module.exports = __webpack_public_path__ + "static/media/sales_icon.7c2d28ba.svg";